module.exports = __webpack_public_path__ + "assets/img/bjimg4.dd238229.png";